import { render, staticRenderFns } from "./DotorTab.vue?vue&type=template&id=7231644b&scoped=true&"
import script from "./DotorTab.vue?vue&type=script&lang=js&"
export * from "./DotorTab.vue?vue&type=script&lang=js&"
import style0 from "./DotorTab.vue?vue&type=style&index=0&id=7231644b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7231644b",
  null
  
)

export default component.exports